import './ParameterVideos.scss';
import { ParameterModel, VideoUrlModel } from 'types/trackmanParameters';

import Paragraph from 'components/TextComps/Paragraph';
import VideoThumbnail from 'components/VideoThumbnail/VideoThumbnail';
import { useTranslation } from 'react-i18next';
import { VideoPlayer } from 'components/VideoPlayer/VideoPlayer';

type Props = {
  visibleParameter: ParameterModel;
  visibleVideo: VideoUrlModel;
  setVisibleVideo: (video: VideoUrlModel) => void;
};

export const ParameterVideos = ({ visibleParameter, visibleVideo, setVisibleVideo }: Props) => {
  const { t } = useTranslation();
  const videoUrl = `https://www.youtube.com/embed/${visibleVideo.videoUrl}?autoplay=0&amp;rel=0&amp;fs=1&enablejsapi=1&playerapiid=player&amp;wmode=opaque&amp;hl=en_US&amp;cc_lang_pref=en_US`;

  return (
    <div className='videos-info'>
      <div className='video-content'>
        <VideoPlayer
          url={videoUrl}
          title={visibleVideo.label}
          allowedFeatures='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen'
          customStyles={{ width: 790, height: 440 }}
        />
      </div>
      <h3>{t('Videos', { ns: 'trackmanParameters' })}</h3>
      <Paragraph>
        <strong>{t('WhatIsThisParameter', { ns: 'trackmanParameters', parameterTitle: visibleParameter.title })}</strong>
      </Paragraph>
      {visibleParameter.videoUrls.length > 1 ? (
        <div className='videos-list'>
          {visibleParameter.videoUrls.map((video: VideoUrlModel) => (
            <VideoThumbnail key={video.videoUrl} video={video} setVisibleVideo={setVisibleVideo} />
          ))}
        </div>
      ) : (
        <></>
      )}
    </div>
  );
};

export default ParameterVideos;
